export default __webpack_public_path__ + "static/media/redeem-bonus1-m-3.e3bee8bd.webp";